import {withTranslation} from "react-i18next";
import {useSelector} from "react-redux/es/exports";
import {useNavigate, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import saveService, {getServiceById} from "../../services/seriesService";
import Button from "../../components/Button";
import {MdOutlineDataSaverOff} from "react-icons/md";
import SelectComponent from "../../components/SelectComponent";
import {getList} from "../../services/service";
import MultiSelectComponent from "../../components/MultiSelectComponent";
import TreeSelectComponent from "../../components/TreeSelectComponent";
import {toast} from "react-toastify";
import UpButton from "../../components/UpButton";
import DeleteButton from "../../components/DeleteButton";
import {Select} from "antd";

const AddSalesCategory = ({t}) => {
  const {token} = useSelector((state) => state.user);
  const navigate = useNavigate();
  const {id} = useParams();
  const [form, setForm] = useState({
    name: "",
    description: "",
    price: null,
    currencyId: null,
    freeForTariffs: [],
    profileSystemIds: []
  });
  const [isLoading, setIsLoading] = useState(false);

  const [currencies, setCurrencies] = useState([]);
  const [tariffs, setTariffs] = useState([]);
  const [profileSeries, setProfileSeries] = useState([]);

  useEffect(() => {
    if (id) {
      fetchDataById().then(()=>{
        getCurrencyList();
        getTarifs();
        fetchTreeList();
      });
    } else {
      getCurrencyList();
      getTarifs();
      fetchTreeList();
      return;
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (evt) => {
    setIsLoading(true);
    evt.preventDefault();
    const response = await saveService(
      `${process.env.REACT_APP_HOST_BASE_URL}/v1/sale-categories`,
      token,
      form
    );
    if (response.success) {
      setIsLoading(false);
      navigate("/sales_category");
      toast.success(id ? t('action.edit_success') : t('action.add_success'), {
        position: "bottom-right",
        autoClose: 3000,
        closeOnClick: true,
        className: "add-success"
      });
    } else {
      setIsLoading(false);
      navigate("/error", {
        state: {
          status: response.status,
          message: response.message ? response.message : null,
        },
      });
    }
  };
  const fetchDataById = async () => {
    const response = await getServiceById(
      `${process.env.REACT_APP_HOST_BASE_URL}/v1/sale-categories/${id}`,
      token
    );
    if (response.success) {
      setForm(response.data);
    } else {
      navigate("/error", {
        state: {
          status: response.status,
          message: response.message ? response.message : null,
        },
      });
    }
  };

  const getCurrencyList = async () => {

    let jsonTexture = await getList(`${process.env.REACT_APP_HOST_BASE_URL}/v1/currency/list`, token);
    setCurrencies(jsonTexture?.data);
  };
  const getTarifs = async () => {

    let jsonTexture = await getList(`${process.env.REACT_APP_HOST_BASE_URL}/v1/sale-categories/tariff/list`, token);
    let tariffs = jsonTexture?.data.map((item, index) => {
      return {
        value: item,
        name: item
      };
    });
    setTariffs(tariffs);
  };

  const fetchTreeList = async () => {
    const response = await getList(
      `${process.env.REACT_APP_HOST_BASE_URL}/v1/profile/system/list/tree`,
      token
    );
    if (response.success) {
      setProfileSeries(response.data);
    } else {
      navigate("/error", {
        state: {
          status: response.status,
          message: response.message ? response.message : null,
        },
      });
    }
  };
  const onChangeFreeForTariffs = (value) => {
    setForm({...form, freeForTariffs: value})
  }

  const onPriceChange = (value) => {
    setForm({...form, currencyId: value.id})
  }

  const onChangeProfileSeries = (value) => {
    console.log(value);
    setForm({...form, profileSystemIds: value})
  }

  return (
    <div className="px-4 py-4 sm:px-6 lg:px-8">
      <h1 className="mb-5 text-xl font-semibold text-gray-900">
        {id ? `${t(`update_sales_category`)}` : `${t(`add_sales_category`)}`}
      </h1>
      <form onSubmit={handleSubmit}>
        <div className="overflow-hidden shadow sm:rounded-md">
          <div className="px-4 py-5 bg-white sm:p-6">
            <div className="grid grid-cols-6 gap-6">
              <div className="col-span-6 sm:col-span-3">
                <label
                  htmlFor="name"
                  className="block text-sm font-medium text-gray-700"
                >
                  {t(`name`)}
                </label>
                <input
                  type="text"
                  name="name"
                  id="name"
                  required
                  autoComplete="name"
                  defaultValue={form?.name}
                  className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  onChange={(e)=>{
                    setForm((prev)=>{
                      return {
                        ...prev,
                        name: e.target.value
                      }
                    })
                  }}
                />
              </div>
              <div className="col-span-6 sm:col-span-3">
                <label
                  htmlFor="price"
                  className="block text-sm font-medium text-gray-700"
                >
                  {t('price')}
                </label>

                <input
                  type="number"
                  name="price"
                  id="price"
                  required
                  autoComplete="price"
                  step={1}
                  value={form?.price}
                  onChange={(e) => {
                    setForm((prev) => {
                      return {
                        ...prev,
                        price: e.target.value
                      }
                    })
                  }}
                  className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                />
              </div>
              <div className="col-span-6 sm:col-span-3">

                <SelectComponent
                  data={currencies}
                  title={t('currency')}
                  item={form ? currencies?.find(ti => ti.id === form?.currencyId) : null}
                  onchange={onPriceChange}
                />
              </div>
              <div className="col-span-6 sm:col-span-3">
                <label
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  {t('tariff')}
                </label>
                <Select
                  mode="multiple"
                  allowClear
                  style={{width: '100%'}}
                  placeholder="Please select"
                  value={form.freeForTariffs}
                  onChange={onChangeFreeForTariffs}
                  options={tariffs}
                />

              </div>
              <div className="col-span-6 sm:col-span-3">
                <label
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  {t('profile_system_list')}
                </label>
                <TreeSelectComponent
                  onChange={onChangeProfileSeries}
                  tree={profileSeries}
                  treeSelectedId={form.profileSystemIds}
                  multiple={true}
                />
              </div>
            </div>
          </div>
          <div className="flex justify-end px-4 py-3 text-right bg-gray-50 sm:px-6">
            <Button type="button" to="/sales_category" btnName={t(`backward`)}/>
            <button
              type="submit"
              className="text-white bg-blue-700 hover:bg-blue-800  font-medium rounded-lg text-sm px-5 py-1.5 text-center  dark:bg-blue-600 dark:hover:bg-blue-700  inline-flex items-center"
            >
              {t(`save`)}
              {isLoading ? (
                <svg
                  role="status"
                  className="inline w-4 h-4 ml-1 text-white animate-spin"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="#E5E7EB"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentColor"
                  />
                </svg>
              ) : (
                <MdOutlineDataSaverOff className="w-4 h-4 ml-1"/>
              )}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default withTranslation()(AddSalesCategory)